// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"24d0cb32","212":"211a8b80","404":"6d8f4248","424":"2e258573","588":"ce86e526","684":"6dd5c19c","720":"4ea5dd8d","776":"49a8f49d","780":"1442eba0","804":"272e3d74","860":"4aaed673","928":"33e09923","996":"f5bde874"}[chunkId] + ".chunk.js";
};